import { Flex } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import P3Medium from 'components/typography/P3Medium';
import { DepartmentRow } from 'components/tables/data/department/types';

/**
 * Column for the supports KEP indicator.
 */
export default function SupportsKepColumn({ data: { supportsKep } }: { data: DepartmentRow }) {
  const style = {
    borderRadius: '40px',
  };

  if (supportsKep) {
    return (
      <Flex bg="green.0" gap={4} py={0} pl={4} pr={8} align="center" style={style}>
        <IconCheck size={16} color="#2F9E44" />
        <P3Medium color="green.9">Áno</P3Medium>
      </Flex>
    );
  }

  return (
    <Flex bg="red.0" gap={4} py={0} pl={4} pr={8} align="center" style={style}>
      <IconX size={16} color="#C92A45" />
      <P3Medium color="red.9">Nie</P3Medium>
    </Flex>
  );
}
